<template>
  <div class="public_main_bgc">
    <!-- :style="{ backgroundImage: 'url(' + dataDetail.cover_url + ')' }" -->
    <div
      class="topBg"
      v-loading="!dataDetail"
      :style="{
        'background-image': `url(${require('@/assets/images/banner/zt' +
          dataDetail.cover_id +
          '.png')})`,
      }"
    >
      <div class="deatilBox">
        <h4 class="ellipsis-2">{{ dataDetail.title }}</h4>
        <p class="timeSty mt10">创建时间：{{ dataDetail.create_time }}</p>
        <p class="conSty ellipsis-2 mt25">{{ dataDetail.content }}</p>
        <div class="bottomBox df dfb">
          <div class="bom1 df">
            <h4>{{ dataDetail.type_str }}</h4>
            <template v-if="dataDetail.label">
              <p
                v-for="(item, index) in dataDetail.label.split(',')"
                :key="index"
              >
                {{ item }}
              </p>
            </template>
          </div>
          <div class="bom2 df">
            <p class="mr20">
              直播场次：<span>{{ dataDetail.live_count }}</span> 场
            </p>
            <el-button
              @click="collect"
              icon="el-icon-star-off"
              class="btn"
              :class="dataDetail.is_collect == 1 ? 'okBtn' : ''"
              >{{ dataDetail.is_collect == 1 ? "已收藏" : "收藏" }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div class="public-width pb15">
      <!-- 筛选 -->
      <div class="select_box">
        <div class="select_left">
          <div class="xueduan">
            <div
              class="xueduan_block cursor"
              :class="form.search_status == item.id ? 'active_block' : ''"
              v-for="(item, index) in type2List"
              :key="index"
              @click="changeType(item.id, 'search_status')"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="df dfb">
            <div class="sousuo-box">
              <div class="box-right">
                <div class="sousuo">
                  <el-input
                    placeholder="请输入搜索关键词"
                    v-model="form.keyword"
                    clearable
                  ></el-input>
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="seletBtn"
                  ></el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainCen">
        <div class="ulBox df dfw" v-if="total">
          <div
            class="liBox cp mb16"
            v-for="(item, index) in dataList1"
            :key="index"
            @click="goMsLiveDetails(item.id)"
          >
            <div class="imgbox">
              <img
                class="imgbig"
                v-if="item.cover_url"
                :src="item.cover_url"
                alt=""
              />
              <img
                v-else
                class="imgbig"
                src="@/assets/images/banner/home_news_pic.png"
                alt=""
              />
              <div
                class="imgAbout1 tc line-h20"
                :class="
                  item.status == 1
                    ? 'bg1'
                    : item.status == 2
                    ? 'bg2'
                    : item.playback_resource_url
                    ? 'bg3'
                    : 'bg4'
                "
              >
                {{
                  item.status == 1
                    ? "预告"
                    : item.status == 2
                    ? "直播中"
                    : item.playback_resource_url
                    ? "回放"
                    : "已结束"
                }}
              </div>
              <div class="imgAbout3 df line-h24" v-if="item.status == 2">
                <div class="mt7 mr5"></div>
                <p>直播中</p>
              </div>
              <div class="imgAbout2 df line-h24" v-else>
                <div class="flex mt3 mr5">
                  <i class="el-icon-caret-right"></i>
                </div>
                <p>
                  {{ item.start_date }} <i class="ml3 mr3"></i>
                  {{ item.start_time.substring(0, 5) }}~{{
                    item.end_time.substring(0, 5)
                  }}
                </p>
              </div>
            </div>
            <div class="txtBox">
              <h4 class="ellipsis-2 mb10">{{ item.title }}</h4>
              <div class="lableBox df mb10">
                <p v-for="(item, index) in item.label.split(',')" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="df dfb">
                <p>
                  {{
                    item.type == 1
                      ? "四名沙龙"
                      : item.type == 2
                      ? "四名论坛"
                      : item.type == 2
                      ? "竞赛活动"
                      : "四名伴我行"
                  }}
                </p>
                <p>浏览人次：{{ item.view_count }}</p>
              </div>
            </div>
          </div>
        </div>
        <el-empty :image-size="50" v-else description="暂无数据"></el-empty>
        <el-pagination
          v-if="total"
          class="tc mt30 mb30"
          background
          @current-change="handleCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.limit"
          layout="total, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import * as msAllApi from "@/api/teacherStudio/msAllApi";
export default {
  data() {
    return {
      type2List: [
        { id: 0, name: "全部" },
        { id: 1, name: "预告" },
        { id: 2, name: "直播中" },
        { id: 3, name: "已结束" },
      ],
      dataList1: [],
      total: 0,
      form: {
        keyword: "",
        topic_id: "",
        search_status: 0,
        page: 1,
        limit: 15,
      },
      dataDetail: {},
    };
  },

  created() {
    if (this.$route.query.id) {
      this.form.topic_id = this.$route.query.id;
      this.getDataShow();
    }
    this.getList1();
  },
  methods: {
    collect() {
      if (!localStorage.getItem("unserInfoData")) {
        this.$message.warning("请先进行登录~");
        setTimeout(() => {
          localStorage.setItem("oldUrl", JSON.stringify(location.href));
          this.$router.push({
            path: "/logo",
          });
        }, 1000);
        return;
      }
      msAllApi.putcollect({ id: this.$route.query.id }).then((res) => {
        if (this.dataDetail.is_collect == 1) {
          this.$message.success("已取消收藏！");
        } else {
          this.$message.success("已收藏！");
        }
        this.getDataShow();
      });
    },
    changeType(val, name) {
      this.form[name] = val;
      this.getList1();
    },
    getDataShow() {
      msAllApi
        .TeachingStudioTopicDetail({ id: this.$route.query.id })
        .then((res) => {
          this.dataDetail = res.data.data;
        });
    },
    getList1() {
      let param = this.form;
      param.search_status = param.search_status == 0 ? "" : param.search_status;
      param.search_type = param.search_type == 0 ? "" : param.search_type;
      msAllApi.LiveList(this.form).then((res) => {
        this.dataList1 = res.data.data.data;
        this.total = res.data.data.total;
      });
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.getList1();
    },
    seletBtn() {
      this.form.page = 1;
      this.getList1();
    },
    // 跳转直播详情
    goMsLiveDetails(id) {
      this.$router.push({
        name: "MsLiveDetails",
        query: { id: id },
      });
    },
    setText(str) {
      let words = str
        .replace(/<[^<>]+>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/&rdquo;/gi, "")
        .replace(/&ldquo;/gi, ""); //这里是去除标签
      return words.replace(/\s/g, ""); //这里是去除空格
    },
  },

  mounted() {},
};
</script>
<style lang="scss" scoped>
.topBg {
  width: 100%;
  height: 304px;
  background-size: 100% 100%;
  position: relative;

  .deatilBox {
    width: 1280px;
    margin: 0 auto;
    text-align: left;
    padding-top: 30px;

    h4 {
      font-size: 40px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }

    .timeSty {
      font-size: 14px;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      text-align: center;
    }

    .conSty {
      font-size: 16px;
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
    }

    .bottomBox {
      width: 1280px;
      position: absolute;
      bottom: 0;
      height: 56px;
      background: rgba(255, 255, 255, 1);
      border-radius: 8px 8px 0 0;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      > div {
        align-items: center;
        width: 50%;
      }

      .bom1 {
        flex: 1;
        overflow: hidden;
        i {
          color: #29acf6;
        }

        h4 {
          font-size: 18px;
          font-weight: bold;
          color: rgb(51, 51, 51);
          white-space: nowrap;
        }

        p {
          margin-left: 9px;
          background: rgba(229, 244, 255, 1);
          border-radius: 4px;
          font-size: 16px;
          font-weight: normal;
          color: rgba(4, 147, 255, 1);
          padding: 4px 10px;
          text-align: center;
          white-space: nowrap;
        }
      }

      .bom2 {
        width: 300px;
        justify-content: right;

        p {
          font-size: 16px;
          font-weight: normal;
          color: rgba(51, 51, 51, 1);

          span {
            color: #ff8201;
            font-weight: bold;
          }
        }

        .btn {
          // font-weight: bold;

          // /deep/.el-icon-star-off {
          //   font-weight: bold;
          // }
          width: 69px;
          height: 30px;
          background: rgba(229, 244, 255, 1);
          border: 1px solid rgba(4, 147, 255, 1);
          border-radius: 8px;
          padding: 0;
          color: rgb(52, 137, 255);
        }

        .okBtn {
          color: #3489ff;
          border: 1px solid #3489ff;

          /deep/.el-icon-star-off {
            color: #3489ff;
          }
        }
      }
    }
  }
}

.public-width {
  width: 1280px;
  margin: 0 auto;
  text-align: left;

  .select_box {
    border-radius: 0 0 8px 8px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 14px;
    padding-bottom: 14px;

    .select_left {
      flex: 1;
      overflow: hidden;
      display: flex;
      justify-content: space-between;

      .xueduan {
        display: flex;
        align-items: center;

        p {
          margin-right: 20px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }

        .xueduan_block {
          display: inline-flex;
          margin-right: 20px;
          font-size: 16px;
          color: #333;
        }

        .active_block {
          color: #3489fe;
          position: relative;
          &::after {
            content: "";
            display: inline-block;
            width: 100%;
            height: 3px;
            background: rgba(52, 137, 255, 1);
            border-radius: 2px;
            background: #3489fe;
            position: absolute;
            bottom: -6px;
          }
        }
      }

      .sousuo-box {
        display: flex;
        align-items: center;

        p {
          flex-shrink: 0;
          margin-right: 20px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }

        .box-right {
          flex: 1;
          overflow: hidden;
          display: flex;
          justify-content: space-between;

          .sousuo {
            width: 242px;
            display: flex;

            /deep/ .el-input {
              flex: 1;
              overflow: hidden;
              height: 36px;
              border-radius: 8px 0px 0px 8px;
              .el-input__inner {
                height: 36px;
                border-radius: 8px 0px 0px 8px;
                border-color: rgb(170, 185, 221);
                background: rgb(235, 241, 255);
                &::placeholder {
                  color: rgb(170, 185, 221);
                }
              }
              .el-input__icon {
                line-height: 36px;
              }
            }

            /deep/ .el-button {
              width: 36px;
              height: 36px;
              border-radius: 0px 8px 8px 0px;
              padding: 0;
              background: rgb(79, 95, 116);
              border-color: rgb(79, 95, 116);
            }
          }
        }
      }
    }

    .select_right {
      .create {
        width: 140px;
        height: 38px;
        background: #ff8201;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 700;
      }
    }
  }

  .mainCen {
    .ulBox {
      .liBox {
        width: 243px;
        height: 270px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        box-sizing: border-box;
        overflow: hidden;
        margin-right: 16px;
        transition: all 0.3s ease-in-out;

        &:hover {
          transform: translateY(-8px);
        }

        &:nth-child(5n) {
          margin-right: 0;
        }

        .imgbox {
          width: 100%;
          height: 137px;
          position: relative;

          .imgAbout1 {
            position: absolute;
            top: 0;
            left: 0;
            width: 52px;
            height: 20px;
            border-radius: 8px 0 8px 0;
            font-size: 12px;
            font-weight: bold;
            color: #ffffff;

            &.bg1 {
              background: #409eff;
            }

            &.bg2 {
              background: #51b875;
            }

            &.bg3 {
              background: #ff7a29;
            }

            &.bg4 {
              background: #999;
            }
          }

          .imgAbout2,
          .imgAbout3 {
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 24px;
            color: #fff;
            font-size: 14px;
            justify-content: center;

            > div {
              width: 14px;
              height: 14px;
              border: 1px solid #fff;
              border-radius: 50%;
            }
          }

          .imgAbout3 {
            background: rgb(255, 122, 41);

            > div {
              width: 10px;
              height: 11px;
              background: url(../../../../assets/images/live_icon.png);
              border-radius: 0;
              border: 0;
              display: block;
            }
          }
        }

        .txtBox {
          padding: 16px;
          h4 {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #2a3037;
          }

          .lableBox {
            height: 23px;
            flex-wrap: wrap;
            overflow: hidden;

            p {
              padding: 2px 6px;
              background: #e5f4ff;
              border-radius: 4px;
              margin-right: 10px;
              text-align: center;
              color: #0493ff;
              font-size: 14px;
            }
          }

          div {
            p {
              font-size: 14px;
              color: rgba(153, 153, 153, 1);
            }
          }
        }
      }
    }
  }

  .mainZhuan {
    .ulBox {
      .liBox {
        width: 410px;
        height: 200px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        margin-right: 25px;

        &:nth-child(3n) {
          margin-right: 0;
        }

        .topBox {
          width: 100%;
          height: 150px;
          padding: 30px 20px 10px 20px;
          box-sizing: border-box;
          border-radius: 8px 8px 0 0;
          background-size: 100% 100%;

          h4 {
            width: 300px;
            height: 60px;
            font-size: 20px;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }

          .lableBox {
            height: 23px;
            flex-wrap: wrap;
            overflow: hidden;

            p {
              padding: 2px 6px;
              background: rgba(255, 255, 255, 0.3);
              border-radius: 4px;
              margin-right: 10px;
              text-align: center;
              color: #fff;
              font-size: 14px;
            }
          }
        }

        .bomm {
          align-items: center;
          height: 50px;
          padding: 0 30px;

          h4 {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
          }

          p {
            color: #fff;
            background: #3489ff;
            padding: 4px 6px;
            border-radius: 4px;
          }
        }
      }
    }
  }
}
</style>